export default {"src":"/_next/static/media/camera-shutter.fbb1d72b.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};